const FINANCIAL_REPORT = {
  title: 'Restituições',
  subtitle:
    'Valores repassados com base nos produtos vendidos, operações e desempenho, de acordo com seu contrato.',
  weeksSummary: {
    title: 'Resumo das semanas',
    downloadReportButton: 'Baixar relatório',
    weekSelection: {
      to: 'à',
      of: 'de',
      filteredFrom: 'Filtrado de:',
    },
    reimbursementValueTitle: 'Valor restituído',
    reimbursementCategories: {
      markup: {
        title: 'Markup',
        description: 'Markup na venda dos produtos Ambev.',
      },
      shipping: {
        title: 'Fretes',
        description:
          'Diferença entre os valores de entrega negociado com você e os pagos pelos clientes, incluindo taxas adicionais.',
      },
      couponAndDiscount: {
        title: 'Cupons e Descontos',
        description: 'Valores de cupons e descontos aplicados nos pedidos.',
      },
      incentive: {
        title: 'Incentivos',
        description:
          'Valores operacionais pagos de acordo com as metas e indicadores atingidos.',
      },
      marketPlace: {
        title: 'Taxas e Comissões',
        description: 'Cobranças como plataforma e marketplace.',
      },
      manualPayment: {
        title: 'Pagamentos Manuais',
        description:
          'Ajustes e correções de valores referentes a períodos passados ou atuais.',
      },
    },
    errorFetchingData:
      'Não conseguimos recuperar os dados nesse momento. Tente novamente mais tarde.',
  },
  downloadModal: {
    title: 'Relatórios',
    subtitle: 'Selecione o filtro para baixar o relatório',
    summaryOption: 'Resumo geral dos relatórios',
    categoryOption: 'Exportar por categoria',
    categorySectionTitle: 'Por categoria',
    categorySectionDetail: '(Com detalhamento)',
    backButton: 'Voltar',
    downloadButton: 'Baixar',
  },
  downloadAlert: {
    downloadingReport: 'Download em andamento',
    downloadSuccess: 'Download concluído!',
    downloadError: 'Não foi possível gerar o relatório. Tente novamente.',
    downloadTimeout: 'Tempo limite excedido. Por favor, tente novamente.',
  },
  restitutionPerWeek: {
    title: 'Por semana',
    subtitle: 'Os valores são repassados na conta cadastrada todas as quintas.',
    emptyMessage: 'Nenhuma semana encontrada',
    table: {
      columns: {
        salesPeriod: {
          header: 'Período de vendas considerado',
          periodLabel: (
            week: number,
            startDay: string,
            endDay: string,
            month: string
          ) => `Semana ${week} - ${startDay} a ${endDay} de ${month}`,
        },
        previsionDate: {
          header: 'Previsão de pagamento',
        },
        status: {
          header: 'Status',
        },
        total: {
          header: 'Valor restituído',
          pendingLabel: '(em cálculo)',
        },
        download: {
          errorGeneratingReport:
            'Houve um erro ao gerar o relatório, tente novamente mais tarde.',
          errorDownloadingReport:
            'Houve um erro ao baixar o relatório, tente novamente mais tarde.',
        },
      },
    },
  },
  analytics: {
    eventNames: {
      reimbursementClicked: 'Reimbursement Clicked',
      reimbursementViewed: 'Reimbursement Viewed',
      reimbursementWeekViewed: 'Reimbursement Week Viewed',
      reimbursementReportsModalClicked: 'Reimbursement Reports Modal Clicked',
      financialReportsActionClicked: 'Financial Reports Action Clicked',
      reimbursementReportsModalViewed: 'Reimbursement Reports Modal Viewed',
    },
    componentCategory: {
      button: 'button',
      iconButton: 'icon button',
      tableRow: 'table row',
    },
    componentName: {
      downloadReport: 'Baixar relatório',
      printWeekSummary: 'Imprimir faturamento',
      weekSummary: 'Detalhes da semana',
      closeModal: 'Fechar',
      downloadReportModal: 'Baixar',
      goBackModal: 'Voltar',
    },
    modalName: {
      downloadReport: 'Reimbursement Reports',
    },
  },
}

export default FINANCIAL_REPORT
